<style src="./NewPermission.scss" lang="scss" scoped></style>
<template lang="html">
  <section class="new-permission right-panel-box" v-click-outside="closePanel">
    <span class="panel-title">Nova Permissão</span>

    <form v-on:submit.prevent="addNew">
      <textbox
        label="Nome da permissão"
        placeholder="Ex.: Coordenador"
        v-model="permissionName" />

      <div class="comandos">
        <button
          class="btn-success"
          :enabled="saveDisabled">
          <icon-check />
          Salvar
        </button>

        <button
          type="button"
          class="btn-danger"
          v-shortkey="['esc']" @shortkey="cancel"
          @click="cancel"><icon-close />Cancelar</button>
      </div>
    </form>
  </section>
</template>

<script>
import { Textbox } from '@/components/primitives'
import {IconCheck, IconClose} from '@/components/primitives/icons'
import { AddNewPermission } from '@/brain/record/permission'

export default {
  name: 'Permission',
  components: {
    Textbox,
    IconCheck,
    IconClose
  },
  data () {
    return {
      saveDisabled: false,
      permissionName: ''
    }
  },
  methods: {
    addNew () {
      this.saveDisabled = true
      AddNewPermission({ name: this.permissionName, permissions: {} })
        .then((response) => {
          this.saveDisabled = false
          this.$emit('success')
          this.permissionName = ''
        })
    },
    closePanel () {
      this.$emit('cancel')
    },
    cancel (e) {
      e.stopPropagation()
      this.closePanel()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/record/permission/right-panel/new-permission/NewPermission.vue